import { createFileRoute } from '@tanstack/react-router';

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

const validateSearch = (search: unknown): { letterRecommendationId?: string } => {
  const searchRecord =
    typeof search === 'object' && search !== null && !Array.isArray(search) ? (search as Record<string, unknown>) : {};
  const letterRecommendationId = searchRecord.letterRecommendationId;

  return {
    ...(typeof letterRecommendationId === 'string' && UUID_PATTERN.test(letterRecommendationId)
      ? { letterRecommendationId }
      : {}),
  };
};

export const Route = createFileRoute('/app/letter-recommendation/')({
  validateSearch,
});
